// extracted by mini-css-extract-plugin
export default {"container":"Submission_container__NweQu","buttonssection":"Submission_buttonssection__v1C2Y","progress":"Submission_progress__omoRt"};